import { Link } from "react-router-dom";

export const MOTTO_JP = "育つ、創る、繋ぐ";
export const MOTTO_ID = "Tumbuh, Mencipta, Menghubungkan";

export function Motto({ size = "sm", align = "left", className = "", testid = "brand-motto" }) {
  const jp = size === "lg" ? "text-2xl sm:text-3xl tracking-[0.2em]" : "text-sm tracking-[0.25em]";
  const idc = size === "lg" ? "text-sm sm:text-base tracking-[0.12em]" : "text-[11px] tracking-[0.08em]";
  return (
    <div data-testid={testid} className={`${align === "center" ? "text-center" : ""} ${className}`}>
      <p className={`font-jpserif text-foreground ${jp}`}>{MOTTO_JP}</p>
      <p className={`mt-1 font-ui uppercase text-muted-foreground ${idc}`}>{MOTTO_ID}</p>
    </div>
  );
}

export function Brand({ to = "/", size = "md", className = "", motto = false }) {
  const s = size === "lg" ? "h-12 w-12 text-2xl" : "h-9 w-9 text-lg";
  return (
    <Link to={to} data-testid="brand-link" className={`inline-flex items-center gap-3 ${className}`}>
      <span className={`hanko ${s}`}>豊</span>
      <span className="leading-tight">
        <span className="block font-ui font-semibold tracking-[0.18em] text-sm uppercase">Yutaka Manabi</span>
        <span className="block font-jpserif text-xs text-muted-foreground">{motto ? `${MOTTO_JP} · ${MOTTO_ID}` : "豊か学び"}</span>
      </span>
    </Link>
  );
}
